module.exports = __webpack_public_path__ + "img/BE0427527696.9bd824c4.svg";